import { Tooltip } from "@material-ui/core";
import {
  ListDataSource,
  MultiSelectFieldWithAutocomplete,
  SelectFieldWithAutocomplete
} from "lego-gui-lib";
import { observer } from "mobx-react";
import React from "react";
import { FieldRenderProps } from "react-final-form";
// @ts-ignore
import SanitizedHTML from "react-sanitized-html";

export interface ForeignKeyFieldOptions {
  dataSource: ListDataSource<{}, {}>;
  valueField: string;
  labelField: string;
  routeDestination?: string;
  isClearable?: boolean;
  filter?: string;
  isMulti?: boolean;
  minWidth?: number;
}

export interface ForeignKeyProps
  extends ForeignKeyFieldOptions,
    FieldRenderProps<any> {
  values?: object;
  readOnly?: boolean;
}

@observer
export class CustomForeignKeyComponent extends React.Component<
  ForeignKeyProps
> {
  public render() {
    const { readOnly, input, isMulti } = this.props;
    const label = this.getTooltipLabel();

    const content = isMulti ? (
      <MultiSelectFieldWithAutocomplete
        {...this.props}
        options={this.getFilteredList()}
        readOnly={readOnly}
      />
    ) : (
      <SelectFieldWithAutocomplete
        {...this.props}
        options={this.getFilteredList()}
        isDisabled={readOnly}
      />
    );

    return (
      <Tooltip title={<SanitizedHTML html={label} />} arrow>
        <span style={{ display: "inline-block", width: "100%" }}>
          {content}
        </span>
      </Tooltip>
    );
  }

  private getFilteredList = () => {
    const { filter, values, dataSource } = this.props;
    if (filter && values) {
      //@ts-ignore
      const value = values[filter];
      //@ts-ignore
      return dataSource.list.filter(item => item[filter] == value); // Intentionally loose ==
    }
    return this.props.dataSource.list;
  };

  private getTooltipLabel = (): string => {
    const { input, isMulti, valueField, labelField } = this.props;
    const selected = this.getFilteredList();

    if (isMulti && Array.isArray(input.value)) {
      const selectedItems = selected.filter(item =>
        //@ts-ignore
        input.value.includes(item[valueField])
      );
      return selectedItems.map(item => this.resolveLabel(item)).join(", ");
    }

    //@ts-ignore
    const selectedItem = selected.find(item => item[valueField] == input.value);
    return selectedItem ? this.resolveLabel(selectedItem) : "";
  };

  private resolveLabel = (item: any): string => {
    const { labelField } = this.props;
    return typeof labelField === "function"
      ? //@ts-ignore
        labelField(item)
      : item[labelField] ?? "";
  };
}
